import { Routes } from '@angular/router';

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'home',
    pathMatch: 'full'
  },

  {
    path: 'home',
    loadComponent: () =>
      import('./components/home/home.component').then(m => m.HomeComponent)
  },
  {
    path: 'chat',
    loadComponent: () =>
      import('./components/chat/chat.component').then(m => m.ChatComponent)
  },
  {
    path: 'medical',
    loadComponent: () =>
      import('./components/form/direct-access-service/medical-consultations/medical-consultations.component')
        .then(m => m.MedicalConsultationsComponent)
  },
  {
    path: 'direct-access-diagnostic-exam',
    loadComponent: () =>
      import('./components/form/direct-access-service/diagnostic-exam-direct-access/diagnostic-exam-direct-access.component')
        .then(m => m.DiagnosticExamDirectAccessComponent)
  },
  {
    path: 'consultant-therapy',
    loadComponent: () =>
      import('./components/form/direct-access-service/consultant-therapy/consultant-therapy.component')
        .then(m => m.ConsultantTherapyComponent)
  },
  {
    path: 'test-labs-routine',
    loadComponent: () =>
      import('./components/form/direct-access-service/test-labs-routine/test-labs-routine.component')
        .then(m => m.TestLabsRoutineComponent)
  },
  {
    path: 'delivery-therapy',
    loadComponent: () =>
      import('./components/form/direct-access-service/delivery-therapy/delivery-therapy.component')
        .then(m => m.DeliveryTherapyComponent)
  },
  {
    path: 'urgencies',
    loadComponent: () =>
      import('./components/form/auth-services/urgencies/urgencies.component')
        .then(m => m.UrgenciesComponent)
  },
  {
    path: 'auth-diagnostic-exam',
    loadComponent: () =>
      import('./components/form/auth-services/diagnostic-exam/diagnostic-exam.component')
        .then(m => m.DiagnosticExamComponent)
  },
  {
    path: 'medicines',
    loadComponent: () =>
      import('./components/form/auth-services/medicines/medicines.component')
        .then(m => m.MedicinesComponent)
  },
  {
    path: 'consulting-room-procedures',
    loadComponent: () =>
      import('./components/form/auth-services/consulting-room-procedure/consulting-room-procedure.component')
        .then(m => m.ConsultingRoomProcedureComponent)
  },
  {
    path: 'case-settlement',
    loadComponent: () =>
      import('./components/cases/case-settlement/case-settlement.component')
        .then(m => m.CaseSettlementComponent)
  },
  {
    path: 'case-searcher',
    loadComponent: () =>
      import('./components/cases/cases-search/cases-search.component')
        .then(m => m.CasesSearchComponent)
  },
  {
    path: 'ambulatory-services',
    loadComponent: () =>
      import('./components/form/auth-services/ambulatory-services/ambulatory-services.component')
        .then(m => m.AmbulatoryServicesComponent)
  },
  {
    path: 'info-cases',
    loadComponent: () =>
      import('./components/dynamic-form-info/dynamic-form-info.component')
        .then(m => m.DynamicFormInfoComponent)
  },
  {
    path: 'survey',
    loadComponent: () =>
      import('./components/chat/survey/survey.component')
        .then(m => m.SurveyComponent)
  },
  {
    path: 'AgendamientoCMFront',
    loadComponent: () =>
      import('./components/form/scheduling-forms/cm-scheduling/cm-scheduling.component')
        .then(m => m.CmSchedulingComponent)
  },
  {
    path: 'ServicioClienteSaludFront',
    loadComponent: () =>
      import('./components/form/scheduling-forms/health-client-service/health-client-service.component')
        .then(m => m.HealthClientServiceComponent)
  },
  {
    path: 'AgendamientoDrummondFront',
    loadComponent: () =>
      import('./components/form/scheduling-forms/drummond-scheduling/drummond-scheduling.component')
        .then(m => m.DrummondSchedulingComponent)
  },
  {
    path: 'ContactUsFront',
    loadComponent: () =>
      import('./components/form/contact-us/contact-us.component')
        .then(m => m.ContactUsComponent)
  },
  {
    path: 'authorization-type-selection',
    loadComponent: () =>
      import('./components/authorization-type-selection/authorization-type-selection.component')
        .then(m => m.AuthorizationTypeSelectionComponent)
  },
  {
    path: 'modify-authorization',
    loadComponent: () =>
      import('./components/form/auth-services/modify-authorization/modify-authorization.component')
        .then(m => m.ModifyAuthorizationComponent)
  },
  {
    path: 'consult-authorization',
    loadComponent: () =>
      import('./components/form/auth-services/consult-authorization/consult-authorization.component')
        .then(m => m.ConsultAuthorizationComponent)
  }
];
